import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Label, TextInput } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechasInterface } from "../../../../../interfaces/FechasInterface";
import { API } from "../../../../../global/global";
import BarraFoto from "../../../../../img/Barra_Foto.png";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import fotoMapa from "../../../../../img/fotoMapa.png";

export const FotosListaPrint = () => {
  const tituloFormulario = "FOTOGRAFÍAS DE VISITA DOMICILIARIA";
  const { control, reset, setValue } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const [edad, setEdad] = useState<number | null>(null);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [photoUrls, setPhotoUrls] = useState<string[]>([]);

  const calcularEdad = (fechaNacimiento: string): number => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFecha = useGetData<FechasInterface[]>({
    url: `/evaluado/${evaluadosList_id}/fecha-visita-bienesinmuebles`,
    name: ["fecha-visita-bienesinmuebles"],
  });

  const generoMap: { [key: string]: string } = {
    M: "Masculino",
    F: "Femenino",
    O: "Otro",
  };

  const generoTexto =
    generoMap[queryEvaluado.data?.genero as string] || "No especificado";

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: queryEvaluado.data.fecha_nacimiento || "",
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (queryFecha.data && queryFecha.data.length > 0) {
      const registroValido = queryFecha.data.find(
        (item) => item.fecha_bienesinmuebles
      );

      if (registroValido) {
        setValue("fecha_bienesinmuebles", registroValido.fecha_bienesinmuebles);
      }
    }
  }, [queryFecha.data, setValue]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluado/${evaluadosList_id}/photos`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.photos && Array.isArray(data.photos)) {
            setPhotoUrls(data.photos);
          }
        })
        .catch((error) => {
          console.error("Error al obtener las fotos:", error);
        });
    }
  }, [evaluadosList_id]);

  return (
    <div className="max-w-[800px] mx-auto p-4 bg-white">
      {/* Marca de agua */}
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>

      <div className="space-y-1 p-1 mt-2">
        <div className="grid grid-cols-3 gap-2">
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fecha_bienesinmuebles" className="mr-2">
              FECHA VISITA:
            </Label>
            <Controller
              name="fecha_bienesinmuebles"
              control={control}
              defaultValue={
                queryFecha.data && queryFecha.data.length > 0
                  ? queryFecha.data[0].fecha_fotovd || ""
                  : ""
              }
              render={({ field }) => (
                <TextInput
                  id="fecha_bienesinmuebles"
                  type="date"
                  placeholder="Seleccionar fecha"
                  disabled={true}
                  {...field}
                  className="w-32"
                />
              )}
            />
          </div>
          
          <div className="col-span-2">
            <Label htmlFor="nombre">NOMBRE:</Label>
            <TextInput
              id="nombre"
              name="nombre"
              value={`${queryEvaluado.data?.nombre || ""} ${
                queryEvaluado.data?.apellido_paterno || ""
              } ${queryEvaluado.data?.apellido_materno || ""}`}
              disabled={true}
            />
          </div>
          
          <div className="col-span-1">
            <Label htmlFor="rfc">RFC:</Label>
            <TextInput
              id="rfc"
              name="rfc"
              value={queryEvaluado.data?.rfc || ""}
              disabled={true}
            />
          </div>
          
          <div className="col-span-1">
            <Label htmlFor="edad">EDAD:</Label>
            <TextInput
              id="edad"
              name="edad"
              value={edad !== null ? edad.toString() : ""}
              disabled={true}
            />
          </div>
          
          <div className="col-span-1">
            <Label htmlFor="sexo">SEXO:</Label>
            <TextInput
              id="sexo"
              name="sexo"
              value={generoTexto}
              disabled={true}
            />
          </div>
          
          <div className="col-span-1">
            <Label htmlFor="estadoCivil">ESTADO CIVIL:</Label>
            <TextInput
              id="estadoCivil"
              name="estadoCivil"
              value={`${queryEvaluado.data?.estado_civil || ""}`}
              disabled={true}
            />
          </div>
          
          <div className="col-span-1">
            <Label htmlFor="escolaridad">ESCOLARIDAD:</Label>
            <TextInput
              id="escolaridad"
              name="escolaridad"
              value={`${queryEvaluado.data?.escolaridad || ""}`}
              disabled={true}
            />
          </div>
          
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fechaNacimiento" className="mr-2">
              FECHA DE NACIMIENTO:
            </Label>
            <TextInput
              id="fechaNacimiento"
              name="fechaNacimiento"
              value={`${queryEvaluado.data?.fecha_nacimiento || ""}`}
              disabled={true}
              type="date"
              className="w-32"
            />
          </div>
          
          <div className="col-span-1">
            <Label htmlFor="curp">CURP:</Label>
            <TextInput
              id="curp"
              name="curp"
              value={queryEvaluado.data?.curp || ""}
              disabled={true}
            />
          </div>
          
          <div className="col-span-1">
            <Label htmlFor="empresa">EMPRESA:</Label>
            <TextInput
              id="empresa_id"
              name="empresa"
              value={queryEvaluado.data?.empresa_id?.nombre || ""}
              disabled={true}
            />
          </div>
        </div>
      </div>

      <div className="bg-slate-100 p-0.5 rounded-lg mt-2">
        <img
          src={BarraFoto}
          alt="HeaderDatosGenerales"
          className="rounded-lg h-auto max-h-20"
        />
      </div>

      {photoUrls.length > 0 ? (
        photoUrls.map((photoUrl: string, index: number) => (
          <div
            key={index}
            className="mb-8 relative border-2 border-gray-300 rounded-lg p-4 flex flex-col items-center"
          >
            <p className="text-center font-medium mb-2">FOTOGRAFÍA {index + 1}</p>
            <img
              src={photoUrl}
              alt={`Fotografía ${index + 1}`}
              className="rounded object-contain max-w-full max-h-96"
            />
          </div>
        ))
      ) : (
        <div className="text-center py-8">
          <p className="text-gray-500">No hay fotografías disponibles</p>
        </div>
      )}
      
      {/* Segunda página para impresión */}
      <div className="break-after-page">
        {/* Marca de agua segunda página */}
        <div className="absolute inset-0 top-[150%] flex justify-center items-center pointer-events-none z-0">
          <div
            className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
            style={{ opacity: 0.1 }}
          >
            CONFIDENCIAL
          </div>
        </div>

        {/* Espacio para más fotos si es necesario */}
        {photoUrls.length > 3 && (
          <>
            {photoUrls.slice(3).map((photoUrl: string, index: number) => (
              <div
                key={index + 3}
                className="mt-4 relative border-2 border-gray-300 rounded-lg p-4 flex flex-col items-center"
              >
                <p className="text-center font-medium mb-2">FOTOGRAFÍA {index + 4}</p>
                <img
                  src={photoUrl}
                  alt={`Fotografía ${index + 4}`}
                  className="rounded object-contain max-w-full max-h-96"
                />
              </div>
            ))}
          </>
        )}

        <div className="p-4 border-t border-gray-300">
          <div className="text-center">
            <p className="text-left text-xs text-gray-600">
              Este documento será de carácter estrictamente confidencial.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};